import PlatformApi from './_platformApi';
import httpClient from '@/apis/base/httpclient';

class userApplicationApi extends PlatformApi {
  constructor() {
    super();
  }

  controllerName = 'UserApplications';

  /**
   * Lấy danh sách ứng dụng của user hiện tại
   * @param {string} category - Category để lọc (optional)
   * @param {boolean} isFavorite - Lọc theo trạng thái yêu thích (optional)
   * @param {boolean} isHistory - Lọc theo trạng thái lịch sử (optional)
   * @returns {Promise} Danh sách ứng dụng với thông tin chi tiết
   */
  getUserApplications() {
    
    const request = {
      url: `${this.getAPIUrl()}/user-applications`
     
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách ứng dụng yêu thích của user hiện tại
   * @returns {Promise} Danh sách ứng dụng yêu thích
   */
  getFavoriteApplications() {
    const request = {
      url: `${this.getAPIUrl()}/favorite-applications`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lưu danh sách user applications (tạo mới hoặc cập nhật)
   * @param {Array} userApplications - Danh sách user applications cần lưu
   * @returns {Promise} Kết quả lưu
   */
  saveUserApplications(userApplications) {
    const request = {
      url: `${this.getAPIUrl()}/save`,
      data: userApplications,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Cập nhật trạng thái active của user application
   * @param {Object} request - Object chứa thông tin cập nhật
   * @param {string} request.app_code - Mã ứng dụng cần cập nhật
   * @param {boolean} request.is_active - Trạng thái active mới
   * @returns {Promise} Kết quả cập nhật
   */
  updateUserApplicationActive(request) {
    const requestConfig = {
      url: `${this.getAPIUrl()}/update-active`,
      data: request,
    };
    return httpClient.putAsync(requestConfig);
  }

  /**
   * Cập nhật trạng thái yêu thích của user application
   * @param {string} app_code - Mã ứng dụng cần cập nhật
   * @param {boolean} is_favorite - Trạng thái yêu thích mới
   * @returns {Promise} Kết quả cập nhật
   */
  updateUserApplicationFavorite(app_code, is_favorite) {
    const requestConfig = {
      url: `${this.getAPIUrl()}/update-favorite`,
      params: {
        app_code: app_code,
        is_favorite: is_favorite
      }
    };
    return httpClient.putAsync(requestConfig);
  }
}

export default new userApplicationApi(); 